import { render, staticRenderFns } from "./sequenceBar.vue?vue&type=template&id=64b2a1b4&scoped=true&"
import script from "./sequenceBar.vue?vue&type=script&lang=js&"
export * from "./sequenceBar.vue?vue&type=script&lang=js&"
import style0 from "./sequenceBar.vue?vue&type=style&index=0&id=64b2a1b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b2a1b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
